<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{ modalTitle }} </h5>
</div>
<div class="modal-body">
    <form [formGroup]="documentsForm">
        <div class="container">
            <div class="datatable table-editor">
                <table
                    class="table datatable-table"
                    mdbTable
                    mdbTableSort
                    #table="mdbTable"
                    #sort="mdbTableSort"
                    [dataSource]="dataSource"
                    [pagination]="pagination"
                    [sort]="sort"
                    width="100%"
                >
                    <thead class="datatable-header">
                        <tr>
                        <ng-container *ngFor="let header of headers">
                            <th
                                [mdbTableSortHeader]="header.field"
                                [disableSort]="header.disableSort"
                                scope="col"
                                class="bg-gris-02 py-2 align-middle th_3"
                                style="white-space: normal;"
                            >
                                {{ header.label.replace("_", " ") | titlecase }}
                            </th>
                        </ng-container>
                        </tr>
                    </thead>
                
                    <tbody class="datatable-body">
                        <tr *ngIf="loading">
                            <td colspan="5" class="p-0 pt-1">
                                <div class="px-2 bg-gris-01 py-5 text-center">
                                    <div width="150" class="spinner-border mt-5 opacity-50" role="status"></div>
                                    <p class="lead text-gris-02 text-center mb-5">
                                        Cargando resultados...
                                    </p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    
                    <tbody class="datatable-body">
                        <tr
                            *ngFor="let register of dataSource; let index = index"
                            scope="row"
                            [cdkTrapFocus]="editElementIndex === index"
                            [cdkTrapFocusAutoCapture]="editElementIndex === index"
                            [ngClass]="{ 'edited-row': editElementIndex === index }"
                        >
                            <td style="min-width: 250px; max-width: 250px; white-space: normal;">
                                <ng-container>
                                    {{ register.CREATED_AT }}
                                </ng-container>
                            </td>
                            <td style="min-width: 200px; max-width: 200px; white-space: normal;">
                                <ng-container>
                                    <img src="./assets/images/pdf-download.svg" alt="PDF" width="24px">
                                    {{ register.CODIGO_DOCUMENTO }}
                                </ng-container>
                            </td>
                            <td style="min-width: 300px; max-width: 300px; white-space: normal;">
                                <ng-container>
                                    {{ register.NOMBRE_DOCUMENTO }}
                                </ng-container>
                            </td>
                            
                            <td>
                                <ng-container>
                                    <button class="btn btn-rounded" (click)="openModalPDF(register.URLDOC)">
                                        <img width="14" class="opacity-50" src="./assets/images/file-text.svg" />
                                    </button>
                                </ng-container>
                            </td>
                        </tr>
                    </tbody>
                </table>
        
                <mdb-table-pagination
                    #pagination
                    rowsPerPageText = 'Registros por Pagina'
                    ofText = 'de'
                    [entries]="10"
                    [disabled]="dataDocumentService.loading"
                ></mdb-table-pagination>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="shadow-0 btn btn-md btn-outline-primary" (click)="modalRefDocuments.close()">
        Volver
    </button>
</div>

<mdb-loading [show]="loading" [fullscreen]="true">
    <div class="loading-spinner">
        <div class="spinner-border loading-icon" role="status"></div>
        <span class="loading-text">Cargando datos...</span>
    </div>
</mdb-loading>